import { object, string, array } from "yup"
import addressModel from "../atoms/address.model"
import bankModel from "../atoms/bank.model"
import kycModel from "../atoms/kyc.model"
import licenceModel from "../atoms/licence.model"
import { email, firstName, ID, lastName, phoneNumber } from "../yup.common"

export default object({
  id: ID,
  vehicleId: ID,
  firstName: firstName.required(),
  lastName: lastName.required(),
  number: phoneNumber.required(),
  email: email
    .transform(v => (v === "" ? null : v))
    .nullable()
    .required("Email is required"),
  address: addressModel,
  secondaryNumber: phoneNumber.transform(v => (v === "" ? null : v)).nullable(),
  kycDetails: array(kycModel),
  bankDetail: bankModel,
  licenceDetail: licenceModel,
  customerId: string(),
})
